/**
 * Sayfa tanıtım turu (onboarding) için kalıcı durum.
 * Değer: 'done' (tamamlandı/atlandı) | 'dismissed' (bir daha gösterme)
 * Sürüm artınca yeni tur tekrar gösterilebilir.
 */
const PREFIX = "tda_tour_";
export const TOUR_VERSION = 1;

function keyFor(page) {
  return `${PREFIX}${page}_v${TOUR_VERSION}`;
}

export function getTourStatus(page) {
  try {
    return localStorage.getItem(keyFor(page));
  } catch {
    return null;
  }
}

export function setTourStatus(page, status) {
  try {
    localStorage.setItem(keyFor(page), status);
  } catch {
    /* localStorage yoksa sessiz geç */
  }
}

/** Tur daha önce tamamlandı veya kalıcı olarak kapatıldı mı? */
export function isTourResolved(page) {
  const s = getTourStatus(page);
  return s === "done" || s === "dismissed";
}

/** Tekrar göstermek için durumu temizle. */
export function resetTourStatus(page) {
  try {
    localStorage.removeItem(keyFor(page));
  } catch {
    /* yoksay */
  }
}
